import React, { FC } from 'react';

import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

import { getLargeImageUrl } from '@utils/images';

type ProductGalleryLightboxProps = {
    activeSlideIndex: number;
    setActiveSlideIndex(slide: number): void;
    isOpen: boolean;
    onClose(): void;
    items: Global.ImageSet[];
};
export const ProductGalleryLightbox: FC<ProductGalleryLightboxProps> = (props) => {
    const { items, isOpen, activeSlideIndex, setActiveSlideIndex, onClose } = props;

    if (!isOpen) {
        return null;
    }

    // Take large images urls
    const originalImages = items.map(getLargeImageUrl);

    return (
        <Lightbox
            mainSrc={originalImages[activeSlideIndex]}
            nextSrc={originalImages[(activeSlideIndex + 1) % originalImages.length]}
            prevSrc={originalImages[(activeSlideIndex + items.length - 1) % originalImages.length]}
            onCloseRequest={onClose}
            onMovePrevRequest={() =>
                setActiveSlideIndex(
                    (activeSlideIndex + originalImages.length - 1) % originalImages.length,
                )
            }
            onMoveNextRequest={() =>
                setActiveSlideIndex((activeSlideIndex + 1) % originalImages.length)
            }
        />
    );
};
